import { render, staticRenderFns } from "./tabVolunteer.vue?vue&type=template&id=21c1568e&"
import script from "./tabVolunteer.vue?vue&type=script&lang=ts&"
export * from "./tabVolunteer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports